export function identify(userId, profileData) {
  if (typeof window.FS === 'undefined') return;
  const {firstName, lastName, email, country, cityOrMunicipality} = profileData;
  window.FS.identify(userId, {
    displayName: `${firstName} ${lastName}`,
    email: email,
    country_str: country,
    city_str: cityOrMunicipality
  });
}

export function clearUserCookie(identifiedOnly) {
  if (typeof window.FS === 'undefined') return;
  window.FS.clearUserCookie(identifiedOnly);
}

export default {
  identify,
  clearUserCookie
};



// WEBPACK FOOTER //
// ./src/services/fullstory.js